var React = require('react');

function SocialDistancing (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_627_238)","key":0},React.createElement("path",{"d":"M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0ZM15 6V10.5H9V6L3 12L9 18V13.5H15V18L21 12L15 6Z","fill":"#55FF8A"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_627_238"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

SocialDistancing.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialDistancing;

SocialDistancing.default = SocialDistancing;
